module.exports = __webpack_public_path__ + "static/media/logLiquidConsumed.3f4f5ced.svg";